import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import KeyUpdates from "./KeyUpdates";
import "./App.css";

function ClosedNotice() {
  return (
    <div className="container">
      <div className="card">
        <h2>Page Closed</h2>
        <p className="description">
          Thanks for contacting ClaimLion Law. This page is now closed.
          However, should you wish to update your marketing preferences
          please email us at{" "}
          <a href="mailto:contactus@claimlionlaw.com">
            contactus@claimlionlaw.com
          </a>{" "}
          and we'll be happy to update these for you.
        </p>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ClosedNotice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/key-updates" element={<KeyUpdates />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
